<template>
    <v-row align="center" class="row--small">
        <v-col cols="12" md="6">
            <v-text-field v-model="emailUser" name="emailUser" v-bind="{ ...$attrs, label }" hide-details />
        </v-col>
        <!-- <v-col cols="auto" class="px-10">@</v-col> -->
        <v-col cols="12" md="6" class="mt-10 mt-md-0">
            <v-combobox v-model="emailHost" name="emailHost" prefix="@" placeholder="직접입력" v-bind="{ ...$attrs, items }" hide-details attach style="position: relative" :menuProps="{ attach: '.email-host' }" class="email-host" />
        </v-col>
        <v-col cols="12" v-if="rules && !$attrs.hideDetails" class="pt-0">
            <v-text-field v-bind="{ value, rules }" class="email-details" />
        </v-col>
    </v-row>
</template>

<script>
const items = ["naver.com", "hanmail.net", "google.com"];
export default {
    props: {
        value: { type: String, default: null }, //email
        label: { type: String, default: null },
        rules: { type: Array, default: null },
    },
    data: () => ({
        items,

        emailUser: null,
        emailHost: null,
    }),
    computed: {
        email() {
            if (this.emailUser && this.emailHost) return `${this.emailUser}@${this.emailHost}`;
            else return null;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
        emailUser() {
            this.emit();
        },
        emailHost() {
            this.emit();
        },
    },
    methods: {
        sync() {
            [this.emailUser = null, this.emailHost = null] = this.value?.split?.("@") || [];
        },
        emit() {
            this.$emit("input", this.email);
        },
    },
};
</script>

<style lang="scss" scoped>
.email-details {
    margin-top: 8px;
    ::v-deep .v-input__slot {
        display: none;
    }
}
::v-deep {
    .v-text-field--outlined .v-text-field__prefix {
        color: #131313;
    }
}
</style>
